import { gql } from "@apollo/client";

// just for ts validation
export const PLACEHOLDER_MUTATION = gql`
  mutation updateMusic {
    updateMusic {
      id
    }
  }
`;
